/**
 * This module provides an interface for the service that creates a short URL out of a longer one,
 * saving the mapping on the server.
 */

import { gql, useMutation } from '@apollo/client';

const COMPRESS_URL = gql`
  mutation CompressUrl($url: String!) {
    compressUrl(sourceUrl: $url)
  }
`;

type ShortUrl = {
  data: {
    compressUrl: 'string';
  };
};

/**
 * Given a URL, call an API to get a shortened version, and returning promise with server response
 *
 * @param copy       if true, copy shortened URL to clipboard
 */
export const useShortUrl = () => {
  const [compressUrl] = useMutation<ShortUrl['data']>(COMPRESS_URL);

  return { fetchShortUrlPromise: (url: string) => compressUrl({ variables: { url } }) };
};
